module.exports = __webpack_public_path__ + "static/media/email.d60fb20c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/email.svg
// module id = 1047
// module chunks = 3